module.exports = "<chassis-datatable-layout [title]=\"title\" [routePrefix]=\"routePrefix\" [pluginPrefix]=\"pluginPrefix\" [toolbar]=\"toolbar\" [(table)]=\"table\" *ngIf=\"(user | async)?.hasRole('admin')\"></chassis-datatable-layout>\n"


//////////////////
// WEBPACK FOOTER
// ./apps/eyewatch/src/app/eyewatch/work-logs/pages/work-logs/index/index.component.html
// module id = ./apps/eyewatch/src/app/eyewatch/work-logs/pages/work-logs/index/index.component.html
// module chunks = main